import { __rest } from "tslib";
import * as React from 'react';
const ExternalLink = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M12,4 L12,5 L5.5,5 C5.224,5 5,5.225 5,5.5 L5,5.5 L5,18.5 C5,18.775 5.224,19 5.5,19 L5.5,19 L18.5,19 C18.776,19 19,18.775 19,18.5 L19,18.5 L19,12 L20,12 L20,18.5 C20,19.327 19.327,20 18.5,20 L18.5,20 L5.5,20 C4.673,20 4,19.327 4,18.5 L4,18.5 L4,5.5 C4,4.673 4.673,4 5.5,4 L5.5,4 L12,4 Z M20,4 L20,9 L19,9 L19,5.707 L12.71,11.997 L12.003,11.29 L18.293,5 L15,5 L15,4 L20,4 Z" })));
};
ExternalLink.displayName = 'ExternalLink';
export default ExternalLink;
//# sourceMappingURL=ExternalLink.js.map